module.exports = {
    import: {
        search: '検索する',
        sure: 'よし',
        downloadResultFile: '結果ファイルをダウンロード',
        importPro: '商品をインポートする',
        downloadTemplate: 'テンプレートをダウンロード',
        table: {
            index: 'シリアル番号',
            fileName: 'ファイル名',
            totalNumber: '合計記録',
            uploadTime: 'アップロード時間',
            completeTime: '完了時間',
            result: '結果の処理',
            uploadUser: 'ユーザーをアップロード',
            operation: '運営'
        },
        hintMsg: {
            success: '成功する',
            failed: '失敗する',
            queryImportFail: 'インポートファイル情報のクエリに失敗しました',
            uploadFailed: 'インポートファイルの処理に失敗しました。再インポートしてください'
        },
        upload: {
            format: 'アップロードされるファイルはExcelスプレッドシートのみです',
            success: 'ファイルのアップロードは成功しました。後で結果ファイルをダウンロードして、処理結果を表示してください',
            fail: '商品をインポートできませんでした',
            incorrectFormat: 'ファイル形式が正しくありません',
            parseFail: 'ファイルの解析に失敗しました',
            noPermission: '製品のインポートに失敗しました、権限がありません'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/import.js